import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="fab-menu"
export default class extends Controller {
  static targets = ["toggle"];

  connect() {
    this.closeOnOutside = this.closeOnOutside.bind(this);
  }

  disconnect() {
    window.removeEventListener("click", this.closeOnOutside);
  }

  toggle(event) {
    event.stopPropagation();
    const isOpen = this.element.classList.toggle("is-open");
    this.toggleTarget.setAttribute("aria-expanded", String(isOpen));

    if (isOpen) {
      window.addEventListener("click", this.closeOnOutside, { once: true });
    } else {
      window.removeEventListener("click", this.closeOnOutside);
    }
  }

  closeOnOutside() {
    this.element.classList.remove("is-open");
    this.toggleTarget.setAttribute("aria-expanded", "false");
  }
}
